import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faCheckCircle, faLightbulb, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import SEO from './SEO';

const Consulting = () => {
  return (
    <div className="services">
      <SEO
        title="Energy Consulting & Planning | CoreNova Renewable Energy"
        description="Energy audits, feasibility studies, system design, ROI analysis, and project planning."
        canonical="https://corenovarenewable.com/services/consulting"
        keywords="consulting, energy audit, feasibility study, system design, ROI"
      />

      <section className="relative bg-gradient-to-r from-primary-green to-secondary-blue text-white py-20 lg:py-32 text-center overflow-hidden">
        <div className="absolute inset-0">
          <img src="/images/service hero.png" alt="Consulting Services" className="w-full h-full object-cover opacity-60" />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-green/40 to-secondary-blue/40"></div>
        </div>
        <div className="container relative z-10">
          <h1 className="text-4xl md:text-6xl font-bold">Energy Consulting & Planning</h1>
          <p className="text-xl md:text-2xl opacity-90">Expert guidance from concept to commissioning</p>
        </div>
      </section>

      <section className="section bg-white">
        <div className="container max-w-6xl">
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl lg:text-4xl font-bold text-dark mb-4">What We Offer</h2>
              <ul className="space-y-3">
                {[
                  'Energy audits and load analysis',
                  'Feasibility studies and ROI modeling',
                  'System design and optimization',
                  'Regulatory and incentive advisory',
                  'Project management and vendor selection',
                ].map((feature, i) => (
                  <li key={i} className="flex items-center gap-3"><FontAwesomeIcon className="text-primary-green" icon={faCheckCircle} /> <span>{feature}</span></li>
                ))}
              </ul>
            </div>
            <div className="space-y-3">
              <h3 className="text-2xl font-bold text-dark">Outcomes</h3>
              {[
                'Optimized system performance',
                'Reduced energy costs',
                'Faster approvals and smoother execution',
                'De-risked investments and predictable returns',
              ].map((b, i) => (
                <div key={i} className="flex items-center gap-3"><FontAwesomeIcon icon={faLightbulb} className="text-primary-green" /><span>{b}</span></div>
              ))}
            </div>
          </div>

          <div className="bg-gray-light p-6 rounded-2xl mt-12">
            <h3 className="text-2xl font-bold text-dark mb-3">Get Started</h3>
            <p className="text-gray mb-4">Book a consulting session tailored to your project goals.</p>
            <a href="/contact" className="btn bg-primary-green text-white inline-flex items-center gap-2">
              Talk to an expert <FontAwesomeIcon icon={faArrowRight} />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Consulting; 